<template>
  <div></div>
</template>

<script>

import { mapActions } from 'vuex'

export default {

  methods: {

    ...mapActions('user', ['doLogoutAll']),

    async logout () {
      try {
        await this.doLogoutAll()
      } catch (error) {
        console.log(error)
        alert('Somehting Went Wrong !')
      } finally {
        this.$router.push({ name: 'login' })
      }
    }
  },

  mounted () {
    this.logout()
  }

}

</script>
